import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getItemsFromApiResponse } from '../../../utils/api'
import { toBuildingAddressSelectItems } from '../../Building'
import { useCloseConfirm } from '../../Form'
import {
  MINIMIZED_MODAL_KEY,
  useMinimizableModal,
  useResizeModal,
} from '../../Modal'
import {
  REQUEST_MINIMIZED_REPLACE_CONFIRMATION,
  RequestForm,
  RequestFormPopupContainer,
  useRequestDraft,
  useRequestDraftCloseConfirmation,
} from '../../Request'
import {
  getIdwellToIdwellBuildings,
  getIdwellToIdwellCategories,
  getIdwellToIdwellCreateRequest,
  getIdwellToIdwellFlats,
  getOnDeleteIdwellToIdwellFileDocument,
} from '../IdwellToIdwell.api'
import { getIdwellToIdwellFiles } from '../IdwellToIdwell.utils'

import { QA_NAME_REQUEST_CREATION_MODAL } from './IdwellToIdwellRequestFormModal.constants'

import * as styles from './IdwellToIdwellRequestFormModal.module.css'

function IdwellToIdwellRequestFormModal({
  minimizedModalScope,
  outboundUuid,
  title = 'Modal.NewServiceRequestTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { fullScreen, handleResizeModal } = useResizeModal()

  const { draftId, setDraft } = useRequestDraft()

  const closeConfirmation = useRequestDraftCloseConfirmation(setDraft)

  const { handleMinimize, isMinimized, setIsDirty } = useMinimizableModal({
    closeConfirmation,
    minimizeKey: MINIMIZED_MODAL_KEY.REQUEST_FORM,
    qaName: QA_NAME_REQUEST_CREATION_MODAL,
    replaceConfirmation: REQUEST_MINIMIZED_REPLACE_CONFIRMATION,
    scope: minimizedModalScope,
    sourceId: draftId,
    title: t(title),
    onClose,
  })

  return (
    <RequestForm
      {...restProps}
      FormContainer={RequestFormPopupContainer}
      apiProps={{
        createRequest: getIdwellToIdwellCreateRequest(outboundUuid),
      }}
      applicantFieldProps={{
        controlProps: {
          className: styles.disabledPointerEvents,
          indicatorsProps: {
            ButtonArrow: null,
            ButtonClear: null,
          },
        },
      }}
      buildingFieldProps={{
        apiParams: { outboundUuid },
        getData: getIdwellToIdwellBuildings,
        getDataItems: getItemsFromApiResponse,
        toPreparedItems: toBuildingAddressSelectItems,
      }}
      categoryFieldProps={{
        apiParams: { outboundUuid },
        getData: getIdwellToIdwellCategories,
        getDataItems: getItemsFromApiResponse,
      }}
      containerProps={{
        hidden: isMinimized,
        isCloseConfirm,
        isFullScreen: fullScreen,
        modal,
        qaName: QA_NAME_REQUEST_CREATION_MODAL,
        setCloseConfirm,
        title,
        onClose,
        onIsDirtyChange: setIsDirty,
        onMinimize: handleMinimize,
        onResize: handleResizeModal,
      }}
      contentComponentProps={{ isFullScreen: fullScreen }}
      fieldsVisibility={{
        showApplicantField: true,
        showAssigneeField: false,
        showDeadlineField: false,
        showRelatedRequestsField: false,
      }}
      filesProps={{
        getFiles: getIdwellToIdwellFiles(outboundUuid),
        onDeleteFile: getOnDeleteIdwellToIdwellFileDocument(outboundUuid),
      }}
      flatFieldProps={{
        apiParams: { outboundUuid },
        getData: getIdwellToIdwellFlats,
        getDataItems: getItemsFromApiResponse,
      }}
      setModal={setModal}
      onCancel={handleClose}
    />
  )
}

export default IdwellToIdwellRequestFormModal
